export const SubmitType = {
  Add: 'added',
  Edit: 'modified',
  Delete: 'deleted',
};

export const LOCAL_SOURCE_ID = 1;



// WEBPACK FOOTER //
// ./src/pages/controlinformation/helpers/index.js